// extracted by mini-css-extract-plugin
module.exports = {"badge":"badge-skins-small-badge-6f5ef25e"};